import { Marker, MeetingWithMarkerID } from '@/types.d';

export const flattenMarkerMeetings = (
  markers: Marker[],
  length: number
): MeetingWithMarkerID[] => {
  if (!markers?.length || length <= 0) {
    return [];
  }

  const visibleMarkers = markers.filter((marker) => marker.marker.map);
  const result: MeetingWithMarkerID[] = [];

  for (const marker of visibleMarkers) {
    for (const meeting of marker.meetings) {
      if (result.length >= length) {
        return result;
      }
      if (meeting.display) {
        result.push({
          ...meeting,
          markerId: marker.markerId,
        });
      }
    }
  }

  return result;
};
